<template>
  <div class="dialog" v-show="isShow">
    <div
      class="dialog-container"
      :class="{ 'has-title': title }"
      v-show="isShow"
      transition="dialog-zoom-in">
      <h3 class="dialog-title" v-if="title">
        {{ title }}
      </h3>
      <p class="dialog-content" v-html="message">

      </p>
      <div class="dialog-footer">
        <a
          class="dialog-btn"
          data-tr-label="对话框组件-按钮-{{ btn.text }}"
          data-tr-property="widget-dialog-btn-{{ $index }}"
          v-for="btn in btns"
          :class="btn.className"
          :key="$index"
          @click="handleClick(btn)">
          {{ btn.text }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dialog',
  props: ['title', 'message', 'btns'],
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    open() {
      this.isShow = true
    },
    close() {
      this.isShow = false
    },
    handleClick(item) {
      item.handle && item.handle()
      this.close()
    }
  }
}
</script>

<style lang="sass">
@import "../../sass/base/_abbrev.scss";

.dialog {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, .55);

  &-container {
    box-sizing: border-box;
    z-index: 1000;
    width: 80%;
    max-height: 80%;
    border-radius: rem(20);
    font-size: rem(32);
    text-align: center;
    background-color: #fff;
    user-select: none;
  }

  &-title {
    padding: rem(40) rem(75);
    line-height: rem(56);
    font-size: rem(36);
    color: #333;
  }

  &-content {
    padding: rem(40) rem(75) rem(35) rem(75);
    line-height: rem(48);
    font-size: rem(32);
    color: #333;
    word-wrap: break-word;
  }

  .has-title &-content {
    margin-top: rem(-25);
    padding: 0 rem(40) rem(35) rem(40);
    line-height: rem(35);
    font-size: rem(24);
  }

  &-footer {
    display: flex;
    border-top: 1px solid #e6e6e6;

    @for $i from 2 through 3 {
      [data-dpr="#{$i}"] & {
        border-top: #{$i}px solid #e6e6e6;
      }
    }
  }

  &-btn {
    display: block;
    flex: 1;
    padding: rem(30) 0;
    font-size: rem(34);
    color: #409cf9;
    text-align: center;

    &:not(:last-child) {
      border-right: 1px solid #e6e6e6;

      @for $i from 2 through 3 {
        [data-dpr="#{$i}"] & {
          border-right: #{$i}px solid #e6e6e6;
        }
      }
    }
  }

  &-zoom-in-transition {
    opacity: 1;
    transition: all .5s ease;
  }

  &-zoom-in-enter,
  &-zoom-in-leave {
    opacity: 0;
    transform: scale3d(.3, .3, .3);
  }
}
</style>



// WEBPACK FOOTER //
// dialog.vue?c6572f4a